
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { CharteFormValues } from "./types";

interface CharteFormProps {
  form: any;
  onSubmit: (values: CharteFormValues) => void;
  isSubmitting: boolean;
}

export const CharteForm = ({ form, onSubmit, isSubmitting }: CharteFormProps) => {
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <h2 className="text-2xl sm:text-3xl font-bold mb-2 text-[#1E3A8A] text-left mx-[50px]">
          Signer la charte
        </h2>
        <p className="text-sm md:text-[15px] text-[#1E3A8A]/90 max-w-2xl mx-[50px]">
          Rejoignez le mouvement des Enfants de la République en signant notre charte.
        </p>

        <FormField 
          control={form.control} 
          name="firstName" 
          render={({ field }) => (
            <FormItem>
              <FormLabel>Prénom</FormLabel>
              <FormControl>
                <Input placeholder="Jean" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )} 
        />
        
        <FormField 
          control={form.control} 
          name="lastName" 
          render={({ field }) => (
            <FormItem>
              <FormLabel>Nom</FormLabel>
              <FormControl>
                <Input placeholder="Dupont" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )} 
        />
        
        <FormField 
          control={form.control} 
          name="email" 
          render={({ field }) => (
            <FormItem>
              <FormLabel>Email</FormLabel>
              <FormControl>
                <Input placeholder="jean.dupont@example.com" type="email" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )} 
        />
        
        <FormField 
          control={form.control} 
          name="phone" 
          render={({ field }) => (
            <FormItem>
              <FormLabel>Téléphone</FormLabel>
              <FormControl>
                <Input placeholder="0601020304" type="tel" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )} 
        />
        
        <FormField 
          control={form.control} 
          name="acceptCharter" 
          render={({ field }) => (
            <FormItem className="flex flex-row items-start space-x-3 space-y-0">
              <FormControl>
                <Checkbox checked={field.value} onCheckedChange={field.onChange} required />
              </FormControl>
              <div className="space-y-1 leading-none">
                <FormLabel>Je signe La Charte des Enfants de la République</FormLabel>
              </div>
              <FormMessage />
            </FormItem>
          )} 
        />
        
        <FormField 
          control={form.control} 
          name="isFrenchCitizen" 
          render={({ field }) => (
            <FormItem className="flex flex-row items-start space-x-3 space-y-0">
              <FormControl>
                <Checkbox checked={field.value} onCheckedChange={field.onChange} required />
              </FormControl>
              <div className="space-y-1 leading-none">
                <FormLabel>Je suis résident(e) en France ou je suis citoyen(ne) français(e)*</FormLabel>
              </div>
              <FormMessage />
            </FormItem>
          )} 
        />
        
        <Button type="submit" className="w-full rounded-lg" disabled={isSubmitting}>
          {isSubmitting ? "Envoi en cours..." : "Signer la charte"}
        </Button>
        
        <p className="text-center text-sm text-gray-600 italic mt-2">
          et recevez gratuitement votre charte "Enfants de la République" personnalisée et numérotée !
        </p>
      </form>
    </Form>
  );
};
